module.exports = __webpack_public_path__ + "img/icon-pyq.4f631242.png";